import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import {map} from 'rxjs/operators';
import {
    POST_FEHLERBESCHREIBUNG_HINZUFUEGEN_ERFOLGREICH,
    PostFehlerbeschreibungHinzufuegenErfolgreichAction
} from '../../../client-ngrx/veranstaltungen';
import {AufgabebemerkungErfolgreichVersendetAction} from './aufgabebemerkung.actions.ui';
import {Observable} from 'rxjs';

@Injectable()
export class AufgabebemerkungPageUiEffects {

    aufgabebemerkungHinzufuegenErfolgreich$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(POST_FEHLERBESCHREIBUNG_HINZUFUEGEN_ERFOLGREICH),
            map((x: PostFehlerbeschreibungHinzufuegenErfolgreichAction) => {
                    return new AufgabebemerkungErfolgreichVersendetAction();
                }
            )
        )
    );
    /*@Effect()
    wsAufgabe$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === AUFGABE_ENTITY;
        }),
        map((x) => <Fehler>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAktuelleAufgabe))),
        filter(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) => aktuelleAufgabe != null),
        filter(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) => aktuelleAufgabe.aufgabe_id === x.aufgabe_id),
        map(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) => {
                return new GetAufgabeFehlerAction(aktuelleAufgabe.aufgabe_id);
            }
        )
    );*/

    constructor(private actions$: Actions,
                private store$: Store<any>) {
    }
}
